import { createCollectionActions } from 'utils/actionsGenerator';

import { types } from './reducer';

export const { fetch, post } = createCollectionActions({
    name: 'listings',
    params: { embeds: 'product.categories,product.media' },
    types,
    url: '/listings',
});



// WEBPACK FOOTER //
// ./src/redux/listings/actions.js